import { Moment } from 'moment';

const ITALY_TZ = 'Europe/Rome';

export function formatDate(date: any): string {
  const d = new Date(date);
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: ITALY_TZ,
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  }).formatToParts(d);
  const p: Record<string, string> = {};
  parts.forEach(({ type, value }) => {
    p[type] = value;
  });
  return `${p.month}/${p.day}/${p.year}`;
}

export function formatDateTimeItaly(date: any): string {
  const d = new Date(date);
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: ITALY_TZ,
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(d);
  const p: Record<string, string> = {};
  parts.forEach(({ type, value }) => {
    p[type] = value;
  });
  return `${p.month}/${p.day}/${p.year} ${p.hour}:${p.minute}:${p.second}`;
}

export function getAttachmentType(attachmentUrl: string) {
  let url = attachmentUrl.toLowerCase().trim();
  if (url.includes('.pdf')) return 'pdf';
  else if (url.includes('.xls') || url.includes('.xlsx')) return 'doc';
  else if (url.includes('.mp3') || url.includes('.aac')) return 'audio';
  else if (url.includes('.eml') || url.includes('.msg')) return 'email';
  else if (url.includes('mp4')) return 'video';
  else return 'image';
}

export function formatMomentRange(range: Moment[] | string | undefined) {
  try {
    if (range && Array.isArray(range)) {
      const [startDate, endDate] = range;

      if (startDate && endDate) {
        return [startDate.startOf('day'), endDate.endOf('day')];
      }
    }
    return undefined;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}
